import React, { useState, useContext } from "react";

import {
  Container,
  Col,
  Row,
  Card,
  CardImg,
  CardHeader,
  CardFooter,
  Collapse,
  Button,
  Modal,
  ModalBody,
  ModalHeader
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";

import { PokeApi, statShorthand } from "../../api";

import "./listing.css";

import TEMP_IMG from "../../images/psyduck_purple.png";
import { NotificationCtx, AuthenticationCtx } from "../../contexts";
import { dao } from "../../api/firebase";

const DetailsCol = props => {
  return (
    <Col
      sm={12}
      md={props.lg ? props.lg : 6}
      style={{
        padding: "0 0 10px 0",
        marginBottom: "0.5em",
        textAlign: "center",
        borderBottom: "1px dotted red"
      }}
    >
      <h5>{props.header}</h5>
      {props.children}
    </Col>
  );
};

const Trait = props => {
  return (
    <Row style={{ margin: "0", padding: "0" }}>
      {props.name}: {props.value}
    </Row>
  );
};

const formatDetailsITEM = data => {
  // TODO
  return <div>TODO</div>;
};

const FormatDetailsMON = data => {
  const [natureDetail, setNatureDetail] = useState(null);

  if (natureDetail === null) {
    PokeApi.getNatureByName(data.details.nature).then(resp => {
      if (typeof resp.increased_stat.name !== "string") return;
      setNatureDetail(
        `${data.details.nature}
         (-${statShorthand(resp.decreased_stat.name)}
         +${statShorthand(resp.increased_stat.name)})`
      );
    });
  }

  return (
    <Row>
      <DetailsCol header="IVs">
        <Trait name="  ATK" value={data.details.ivs.atk} />
        <Trait name="  DEF" value={data.details.ivs.def} />
        <Trait name="  SPD" value={data.details.ivs.spd} />
        <Trait name="SPATK" value={data.details.ivs.spatk} />
        <Trait name="SPDEF" value={data.details.ivs.spdef} />
        <Trait name="   HP" value={data.details.ivs.hp} />
      </DetailsCol>
      <DetailsCol header="EVs">
        <Trait name="  ATK" value={data.details.evs.atk} />
        <Trait name="  DEF" value={data.details.evs.def} />
        <Trait name="  SPD" value={data.details.evs.spd} />
        <Trait name="SPATK" value={data.details.evs.spatk} />
        <Trait name="SPDEF" value={data.details.evs.spdef} />
        <Trait name="   HP" value={data.details.evs.hp} />
      </DetailsCol>
      <DetailsCol header="Traits" lg={12}>
        <Trait
          name="  Nature"
          value={natureDetail ? natureDetail : data.details.nature}
        />
        <Trait name=" Ability" value={data.details.ability} />
        <Trait name="H. Power" value={data.details.hidden_power} />
        <Trait name="  Region" value={data.details.region} />
        <Trait name="     Sex" value={data.details.sex ? "Female" : "Male"} />
      </DetailsCol>
    </Row>
  );
};

const formatDetails = data => {
  return data.details ? FormatDetailsMON(data) : formatDetailsITEM(data);
};

// TODO offer another listing
const OfferModal = props => {
  const { notify } = useContext(NotificationCtx);
  const [priceFormated, setPriceFormated] = useState(
    props.data.price.toString()
  );

  const sendOffer = (_, values) => {
    dao
      .createOffer(
        props.lid,
        props.data.uid,
        props.data.name,
        props.data.price,
        parseInt(values.price)
      )
      .then(() => {
        props.toggle();
        notify("success", <React.Fragment>Offer Sent</React.Fragment>);
      })
      .catch(err => {
        console.log(err);
        notify(
          "danger",
          <React.Fragment>An err occurred. Please try again</React.Fragment>
        );
      });
  };
  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader>Send Offer for {props.data.name}</ModalHeader>
      <ModalBody>
        <AvForm
          onValidSubmit={sendOffer}
          model={{ price: props.data.price.toString() }}
        >
          <AvField
            stlye={{ color: "black" }}
            name="price"
            label="Offer"
            type="number"
            required
            helpMessage={priceFormated}
            onChange={e =>
              setPriceFormated(
                e.target.value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              )
            }
          />
          <Button color="success">Send</Button>
        </AvForm>
      </ModalBody>
    </Modal>
  );
};

const ReportModal = props => {
  const { notify } = useContext(NotificationCtx);

  const report = () => {
    // TODO report submissions
    props.toggle();
    notify("danger", <p>Report submitted, thank you.</p>);
  };

  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader>Report Listing</ModalHeader>
      <ModalBody>
        <Button color="danger" onClick={report}>
          Do you want to report this listing?
        </Button>
      </ModalBody>
    </Modal>
  );
};

/**
 * Collapsable listing card
 */
const ListingCard = props => {
  const { user, toggleModal } = useContext(AuthenticationCtx);
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(props.data);
  const [image, setImage] = useState(TEMP_IMG);
  const [offerOpen, setOfferOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const toggleOfferModal = () => {
    if (user == null) toggleModal();
    else setOfferOpen(!offerOpen);
  };
  const toggleReportModal = () => setReportOpen(!reportOpen);

  if (data.name !== null) {
    data.details
      ? PokeApi.getPokemonByName(data.name).then(poke => {
          setImage(poke.sprites.front_default);
        })
      : PokeApi.getItemByName(data.name).then(item => {
          setImage(item.sprites.default);
        });
  }

  return (
    <a onClick={() => setIsOpen(!isOpen)} style={{ cursor: "pointer" }}>
      <Card body style={style.card}>
        <CardHeader style={style.cardHeader}>
          <p style={{ float: "left" }}>{data.name}</p>
          <p style={{ float: "right" }}>
            {(data.price / 1000)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
            K
          </p>
        </CardHeader>
        <Collapse
          isOpen={!isOpen}
          style={{ textAlign: "center", alignContent: "center" }}
        >
          {props.noImage ? (
            ""
          ) : (
            <CardImg
              src={image}
              top
              style={{ maxWidth: "150px", maxHeight: "150px" }}
            />
          )}
        </Collapse>
        <CardFooter style={style.cardFooter}>
          {props.noSeller ? (
            ""
          ) : (
            <Row>
              <Col style={{ paddingRight: "0" }}>
                <Trait name="seller" value={data.seller} />
              </Col>
            </Row>
          )}
          <Collapse isOpen={isOpen}>
            <Container fluid style={{ marginTop: "0.5em" }}>
              {formatDetails(data)}
              <Row>
                <Col style={{ padding: "0" }}>Listing ID: {props.doc.id}</Col>
              </Row>
            </Container>
            {props.hideModals ? (
              ""
            ) : (
              <React.Fragment>
                <Button
                  color="success"
                  style={{ width: "100%", marginTop: "1em" }}
                  onClick={toggleOfferModal}
                >
                  Send Offer
                  <OfferModal
                    data={data}
                    lid={props.doc.id}
                    isOpen={offerOpen}
                    toggle={toggleOfferModal}
                  />
                </Button>

                <Button
                  color="danger"
                  style={{ width: "100%", marginTop: "1em" }}
                  onClick={toggleReportModal}
                >
                  Report this Listing
                  <ReportModal
                    data={data}
                    isOpen={reportOpen}
                    toggle={toggleReportModal}
                  />
                </Button>
              </React.Fragment>
            )}
          </Collapse>
        </CardFooter>
      </Card>
    </a>
  );
};

const style = {
  card: {
    backgroundColor: "transparent",
    border: "1px solid steelgrey"
  },
  cardHeader: {
    padding: 0,
    backgroundColor: "Transparent",
    fontSize: "1.2em"
  },
  cardFooter: {
    backgroundColor: "transparent"
  }
};

export default ListingCard;
